import axios from 'axios'

import {
  getWallet,
  getWalletFailed,
  getWalletSuccess,
  getAccountWallet,
  getAccountWalletFailed,
  getAccountWalletSuccess,
  postReferralCode,
  postReferralCodeFailed,
  postReferralCodeSuccess,
  getRecentDeposits,
  getRecentDepositsSuccess,
  getRecentDepositsFailed
} from '../store/actions/main'

import {
  getLeaderboardData,
  getLeaderboardDataSuccess,
  getLeaderboardDataFailed
} from '../store/actions/leaderboard'

import {
  claimStake,
  claimStakeFailed,
  claimStakeSuccess
  // getClaimStatus,
  // getClaimStatusFailed,
  // getClaimStatusSuccess
} from '../store/actions/staking'
import {
  removeAppProvider,
  removeAppUserId,
  removeReferralCode
} from './local.helpers'
import { getContractConfig, isEnvProduction } from './app.helpers'

const getWalletAPI = (dispatch, address) => {
  dispatch(getWallet())
  axios
    .get(
      `${process.env.REACT_APP_SALES_API_URL}?wallet=${address}&startTime=${getContractConfig().start}`
    )
    .then((response) => {
      dispatch(getWalletSuccess(response.data))
    })
    .catch((error) => {
      dispatch(getWalletFailed(error))
    })
}

const getAccountWalletAPI = (dispatch, address, hardRefresh = false) => {
  dispatch(getAccountWallet(hardRefresh))
  axios
    .get(`${process.env.REACT_APP_SLS_API_URL}wallet/info?wallet=${address}`)
    .then((response) => {
      dispatch(getAccountWalletSuccess(response.data))
    })
    .catch((error) => {
      dispatch(getAccountWalletFailed(error))
    })
}

const postReferralCodeAPI = (dispatch, address, code) => {
  dispatch(postReferralCode())
  axios
    .post(
      `${process.env.REACT_APP_SLS_API_URL}wallet/referral?wallet=${address}&code=${code}`
    )
    .then((response) => {
      removeReferralCode()
      dispatch(postReferralCodeSuccess(response.data))
    })
    .catch((error) => {
      removeReferralCode()
      dispatch(postReferralCodeFailed(error))
    })
}

const postAppReferralCodeAPI = (dispatch, address, provider, userId) => {
  axios
    .post(
      `${process.env.REACT_APP_SLS_API_URL}wallet/appreferral?wallet=${address}&app_provider=${provider}&app_user_id=${userId}`
    )
    .then(() => {
      removeAppProvider()
      removeAppUserId()
    })
    .catch(() => {
      removeAppProvider()
      removeAppUserId()
    })
}

// @TODO: remove later if no need VIR staking claim
// const getClaimStatusUrl = (address) => {
//   return `${process.env.REACT_APP_SLS_API_URL}wallet/saleclaim?wallet=${address}`
// }
// const getClaimStatusAPI = (dispatch, address) => {
//   dispatch(getClaimStatus())
//   axios
//     .get(getClaimStatusUrl(address))
//     .then((response) => {
//       dispatch(getClaimStatusSuccess(response.data))
//     })
//     .catch((error) => {
//       dispatch(getClaimStatusFailed(error))
//     })
// }

// @TODO: remove later if no need VIR staking claim
const claimStakeAPI = (dispatch, address, signMsgData, accountNumber) => {
  dispatch(claimStake())
  axios
    .post(
      `${process.env.REACT_APP_SLS_API_URL}wallet/saleclaim?wallet=${address}&signedMessage=${signMsgData}&account_number=${accountNumber}`
    )
    .then((response) => {
      dispatch(claimStakeSuccess(response.data))
    })
    .catch((error) => {
      dispatch(claimStakeFailed(error))
    })
}

const getLeaderboardAPI = (dispatch) => {
  dispatch(getLeaderboardData())
  axios
    .get(`${process.env.REACT_APP_LEADERBOARD_URL}?timestamp=${Date.now()}`)
    .then((response) => {
      dispatch(getLeaderboardDataSuccess(response.data))
    })
    .catch((error) => {
      dispatch(getLeaderboardDataFailed(error))
    })
}

const getRecentDepositsAPI = (dispatch) => {
  dispatch(getRecentDeposits())
  axios
    .get(`${process.env.REACT_APP_TIMELINE_URL}?timestamp=${Date.now()}`)
    .then((response) => {
      dispatch(getRecentDepositsSuccess(response.data))
    })
    .catch((error) => {
      dispatch(getRecentDepositsFailed(error))
    })
}

const shareXPostUrl = (address, txHash) => {
  return `https://qiibeefoundation.org/xapi${!isEnvProduction() ? 'testing' : ''}/?wallet=${address}&tx_hash=${txHash}`
}

export {
  getWalletAPI,
  getAccountWalletAPI,
  postReferralCodeAPI,
  postAppReferralCodeAPI,
  // getClaimStatusAPI,
  claimStakeAPI,
  shareXPostUrl,
  getLeaderboardAPI,
  getRecentDepositsAPI
}
